module.exports = __webpack_public_path__ + "img/059.43f08b3e.png";